import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../api";
import { Scanner } from "@yudiel/react-qr-scanner";

import { useI18n } from "../i18n/I18nContext";

export default function Aboutage() {
  const { t, ui } = useI18n();

  const navigate = useNavigate();

  const [operator, setOperator]               = useState("");
  const [now, setNow]                         = useState(new Date());
  const [strategie, setStrategie]             = useState("");
  const [totalStacksInput, setTotalStacksInput] = useState("1");
  const [totalStacks, setTotalStacks]         = useState(1);
  const [stackChoice, setStackChoice]         = useState("");
  const [stackSearch, setStackSearch]         = useState("");
  const [stackList, setStackList]             = useState([]);
  const [rows, setRows]                       = useState(() => makeRows(1));
  const stackBoxRef                           = useRef(null);
  const [showStackList, setShowStackList]     = useState(false);
  const [showStackScanner, setShowStackScanner] = useState(false);
  const [sending, setSending]                 = useState(false);
  const [error, setError]                     = useState("");
  const [success, setSuccess]                 = useState("");
  const [finalStackId, setFinalStackId]       = useState("");
  const [creatingFinal, setCreatingFinal]     = useState(false);
  const [printing, setPrinting]               = useState(false);

  useEffect(() => {
    const raw = localStorage.getItem("user");
    if (raw) { try { setOperator(JSON.parse(raw).username || ""); } catch (e) { console.error(e); } }
  }, []);

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  async function reloadStacks() {
    try {
      const res  = await apiFetch("/api/empilement/list/aboutage");
      if (!res.ok) return;
      const data = await res.json().catch(() => ({}));
      const raw  = Array.isArray(data) ? data : Array.isArray(data.items) ? data.items : [];
      const all  = raw.map((it) => typeof it === "string" ? it : it.StackId || it.stackId || "")
                      .map((x) => String(x).trim()).filter(Boolean);
      setStackList(Array.from(new Set(all)));
    } catch (e) { console.error(e); }
  }

  function setRowField(i, field, value) {
    setRows((prev) => { const next = [...prev]; next[i] = { ...next[i], [field]: value }; return next; });
  }

  useEffect(() => { reloadStacks(); }, []);

  useEffect(() => {
    function handleClickOutside(e) {
      if (stackBoxRef.current && !stackBoxRef.current.contains(e.target)) setShowStackList(false);
    }
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  function normalize(text) {
    return text.toString().toLowerCase().normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, " ").trim();
  }

  const filteredStacks = useMemo(() => {
    const s = normalize(stackSearch);
    return stackList.filter((p) => (!s ? true : normalize(p).includes(s)));
  }, [stackSearch, stackList]);

  useEffect(() => {
    const n = clampInt(totalStacks, 1, 30);
    setRows((prev) => {
      const next = makeRows(n);
      for (let i = 0; i < Math.min(prev.length, next.length); i++) next[i] = { ...next[i], ...prev[i] };
      return next;
    });
  }, [totalStacks]);

  async function handleAddStack() {
    if (!stackChoice) { alert("Merci de sélectionner un ID Stack."); return; }
    const res = await apiFetch("/api/stack/ajout/aboutage", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ stackId: stackChoice }),
    });
    if (!res.ok) { const d = await res.json().catch(() => ({})); alert(d.message || "Erreur ajout stack"); return; }
    setRows((prev) => {
      const idx = prev.findIndex((r) => !r.stackId);
      if (idx === -1) { alert("Tableau complet."); return prev; }
      const next = [...prev]; next[idx] = { ...next[idx], stackId: stackChoice }; return next;
    });
    setStackChoice(""); setStackSearch(""); await reloadStacks();
  }

  async function handleRemoveLastStack() {
    let lastStack = "", lastIdx = -1;
    for (let i = rows.length - 1; i >= 0; i--) {
      if ((rows[i].stackId || "").trim()) { lastStack = rows[i].stackId.trim(); lastIdx = i; break; }
    }
    if (!lastStack) return;
    const res = await apiFetch("/api/stack/supprimer/aboutage", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ stackId: lastStack }),
    });
    if (!res.ok) { const d = await res.json().catch(() => ({})); alert(d.message || "Erreur suppression"); return; }
    setRows((prev) => { const next = [...prev]; next[lastIdx] = { stackId: "", commentaire: "" }; return next; });
    await reloadStacks();
  }

  function handleScanStack(results) {
    if (!results?.length) return;
    const v = (results[0].rawValue || "").trim();
    setStackChoice(v); setStackSearch(v); setShowStackList(false); setShowStackScanner(false);
  }

  function isAndroid() { return /Android/i.test(navigator.userAgent || ""); }

  async function clientPrintFromApi(bodyForApi) {
    const win = window.open("", "_blank");
    if (win) { win.document.write(`<!doctype html><title>Préparation…</title><body>Préparation…</body>`); win.document.close(); }
    const res = await apiFetch("/api/labels/a4", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...bodyForApi, format: "PNG", download: false }),
    });
    if (!res.ok) { const err = await res.json().catch(() => ({})); throw new Error(err.message || `HTTP ${res.status}`); }
    const blob    = await res.blob();
    const blobUrl = URL.createObjectURL(blob);
    const safePN  = String(bodyForApi.pn || "QR").replace(/[^\w\-]+/g, "_").slice(0, 64);
    const fileName = `A4_${bodyForApi.n || 1}x_${safePN}.png`;
    const ANDROID  = isAndroid();
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>${fileName}</title>
    <style>html,body{height:100%;margin:0}
    #bar{position:fixed;inset:auto 0 0 0;background:#111;color:#fff;padding:8px;display:flex;gap:8px;align-items:center;z-index:10}
    #bar button,#bar a{background:#E6FF3E;color:#000;border:0;padding:8px 12px;font-weight:800;cursor:pointer;text-decoration:none}
    .viewer{position:fixed;left:0;right:0;top:0;bottom:44px;width:100%;object-fit:contain;background:#fff}
    </style></head><body>
    <img class="viewer" src="${blobUrl}" alt="Étiquettes"/>
    <div id="bar">
      ${ANDROID ? "" : "<button id='btnPrint'>Imprimer</button>"}
      <a id="btnDownload" href="${blobUrl}" download="${fileName}">Télécharger</a>
      <button id="btnClose">Fermer</button>
    </div>
    <script>
      ${ANDROID ? "" : "btnPrint.onclick=()=>{try{window.focus();window.print();}catch(e){}};"}
      btnClose.onclick=()=>{try{URL.revokeObjectURL('${blobUrl}');}catch(e){};setTimeout(()=>window.close(),100);};
      window.onafterprint=()=>{try{URL.revokeObjectURL('${blobUrl}');}catch(e){};setTimeout(()=>window.close(),200);};
      ${ANDROID ? "" : "setTimeout(()=>{try{window.focus();window.print();}catch(e){}},400);"}
    </script></body></html>`;
    if (win) { win.document.open(); win.document.write(html); win.document.close(); }
    else { const a = document.createElement("a"); a.href = blobUrl; a.download = fileName; a.click(); URL.revokeObjectURL(blobUrl); }
  }

  async function handleCreateFinalStackId() {
    setError(""); setSuccess("");
    if (!strategie.trim()) { setError("Merci de saisir la stratégie d'aboutage."); return; }
    try {
      setCreatingFinal(true);
      const res  = await apiFetch("/api/aboutage/stack/create", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ strategie: strategie.trim(), totalStacks: clampInt(totalStacks, 1, 30), timestamp: new Date().toISOString() }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message || "Erreur création Stack final");
      setFinalStackId(data.stackId || ""); setSuccess("✅ ID Stack final créé.");
    } catch (e) { setError(e.message || "Erreur création Stack final"); }
    finally { setCreatingFinal(false); }
  }

  async function handlePrintFinalStack() {
    if (!finalStackId) { alert("Créer l'ID Stack final d'abord."); return; }
    try {
      setPrinting(true);
      await clientPrintFromApi({ n: 2, pn: finalStackId, detail: `STACK FINAL Aboutage (${strategie || ""})`.trim(), date: new Date().toISOString().split("T")[0] });
      setSuccess("✅ Étiquette générée.");
    } catch (e) { setError(e.message || "Erreur impression"); }
    finally { setPrinting(false); }
  }

  async function handleSubmit(e) {
    e.preventDefault(); setError(""); setSuccess("");
    const n = clampInt(totalStacks, 1, 30);
    if (!strategie.trim())    return setError("Merci de saisir la stratégie d'aboutage.");
    if (!finalStackId.trim()) return setError("Merci de créer l'ID Stack final.");
    const missingIndex = rows.slice(0, n).findIndex((r) => !(r.stackId || "").trim());
    if (missingIndex !== -1)  return setError("Merci de remplir tous les ID Stack.");
    const payload = {
      operator, finalStackId: finalStackId.trim(), strategie: strategie.trim(), totalStacks: n,
      rows: rows.slice(0, n).map((r, idx) => ({ position: idx + 1, stackId: r.stackId || "", commentaire: r.commentaire || "" })),
      timestamp: new Date().toISOString(),
    };
    try {
      setSending(true);
      const res = await apiFetch("/api/aboutage", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
      if (!res.ok) { const data = await res.json().catch(() => ({})); throw new Error(data.message || "Erreur serveur"); }
      setStrategie(""); setTotalStacksInput("1"); setTotalStacks(1);
      setRows(makeRows(1)); setStackChoice(""); setStackSearch(""); setFinalStackId("");
      setSuccess("✅ Données enregistrées.");
    } catch (err) { setError(err.message || "Erreur d'envoi."); }
    finally { setSending(false); }
  }

  const timeStr = now.toLocaleTimeString("fr-FR");
  const dateStr = now.toLocaleDateString("fr-FR", { weekday: "short", day: "2-digit", month: "short", year: "numeric" });

  return (
    <div className="ab-page">
      <div className="ab-card">

        {/* HEADER */}
        <div className="ab-header">
          <span>Aboutage</span>
          <span className="ab-header-sub">Assemblage de stacks</span>
        </div>

        {/* NAV */}
        <div className="ab-nav">
          <button type="button" className="ab-btn-back" onClick={() => navigate("/menu")}>← Retour menu</button>
          <div className="ab-clock">
            <div className="ab-clock-time">{timeStr}</div>
            <div className="ab-clock-date">{dateStr}</div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="ab-form">

          {/* OPÉRATEUR */}
          <div className="ab-operator-badge">
            <span className="ab-operator-dot" />
            {operator ? operator.toUpperCase() : "OPÉRATEUR NON CONNECTÉ"}
          </div>

          {/* STRATÉGIE */}
          <div className="ab-section">
            <div className="ab-section-label">🔧 Stratégie d'aboutage</div>
            <input value={strategie} onChange={(e) => setStrategie(e.target.value)} className="ab-input" placeholder="Ex : AB-CROSS-14…" />
          </div>

          {/* NB STACKS */}
          <div className="ab-section">
            <div className="ab-section-label">📦 Nombre de stacks dans le produit final</div>
            <input
              type="text" inputMode="numeric"
              value={totalStacksInput}
              onChange={(e) => setTotalStacksInput(e.target.value.replace(/[^0-9]/g, ""))}
              onBlur={() => setTotalStacks(clampInt(totalStacksInput, 1, 30))}
              onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); setTotalStacks(clampInt(totalStacksInput, 1, 30)); }}}
              className="ab-input ab-input-center ab-input-small"
            />
          </div>

          {/* SÉLECTION STACK */}
          <div className="ab-section">
            <div className="ab-section-label">🔖 Identifiant Stack</div>
            <div ref={stackBoxRef} style={{ position: "relative" }}>
              <div className="ab-stack-row">
                <input
                  value={stackSearch}
                  onChange={(e) => { setStackSearch(e.target.value); setShowStackList(true); }}
                  onFocus={() => setShowStackList(true)}
                  placeholder="Sélectionner ou filtrer un ID Stack"
                  className="ab-stack-input"
                />
                <button type="button" className="ab-scan-btn" onClick={() => setShowStackScanner(true)} title="Scanner QR">📷</button>
                <button type="button" className="ab-btn-action" onClick={handleAddStack}>+ Ajouter</button>
                <button type="button" className="ab-btn-action ab-btn-danger" onClick={handleRemoveLastStack}>− Supprimer</button>
              </div>

              {showStackList && filteredStacks.length > 0 && (
                <div className="ab-dropdown" onMouseDown={(e) => e.preventDefault()}>
                  {filteredStacks.map((p) => (
                    <div key={p} className="ab-dropdown-item"
                      onClick={() => { setStackChoice(p); setStackSearch(p); setShowStackList(false); }}>
                      {p}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* TABLEAU */}
          <div className="ab-section ab-section-table">
            <div className="ab-section-label">📋 Tableau des stacks</div>
            <div className="ab-table">
              <div className="ab-table-head">
                <div className="ab-th">Position</div>
                <div className="ab-th">Identifiant Stack</div>
                <div className="ab-th">Commentaire</div>
              </div>
              {rows.map((r, idx) => (
                <div key={idx} className={`ab-table-row ${idx % 2 === 0 ? "ab-row-even" : "ab-row-odd"}`}>
                  <div className="ab-td ab-td-pos">{idx + 1}</div>
                  <div className="ab-td">
                    <input value={r.stackId || ""} readOnly className="ab-cell-input ab-cell-readonly" />
                  </div>
                  <div className="ab-td">
                    <input value={r.commentaire || ""} onChange={(e) => setRowField(idx, "commentaire", e.target.value)} className="ab-cell-input" placeholder="Commentaire…" />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* STACK FINAL */}
          <div className="ab-section ab-section-final">
            <div className="ab-section-label">🏁 Stack final</div>
            <div className="ab-final-row">
              <button type="button" className="ab-btn-create" onClick={handleCreateFinalStackId} disabled={creatingFinal}>
                {creatingFinal ? "⏳ Création…" : "🆕 Créer ID Stack final"}
              </button>
              <button type="button" className="ab-btn-print" onClick={handlePrintFinalStack} disabled={!finalStackId || printing}>
                {printing ? "⏳" : "🖨 Print"}
              </button>
            </div>
            <input value={finalStackId} readOnly placeholder="ID Stack final généré automatiquement…"
              className={`ab-input ab-input-center ${finalStackId ? "ab-input-filled" : "ab-input-empty"}`} />
          </div>

          {/* MESSAGES */}
          {error   && <div className="ab-msg ab-msg-error">{error}</div>}
          {success && <div className="ab-msg ab-msg-success">{success}</div>}

          {/* SUBMIT */}
          <div className="ab-submit-row">
            <button type="submit" disabled={sending} className="ab-btn-submit">
              {sending ? "⏳ Envoi…" : "✔ Confirmation Stack finale"}
            </button>
            <button type="button" className="ab-btn-time">
              Time
              <div className="ab-btn-time-sub">{timeStr}</div>
            </button>
          </div>

        </form>
      </div>

      {/* SCANNER MODAL */}
      {showStackScanner && (
        <div className="ab-modal-backdrop" onClick={() => setShowStackScanner(false)}>
          <div className="ab-modal-scanner" onClick={(e) => e.stopPropagation()}>
            <div className="ab-modal-title">📷 Scanner un QR code Stack</div>
            <div style={{ borderRadius: 10, overflow: "hidden" }}>
              <Scanner onScan={handleScanStack} onError={(e) => console.error(e)} constraints={{ facingMode: "environment" }} />
            </div>
            <button type="button" className="ab-btn-close-scanner" onClick={() => setShowStackScanner(false)}>✕ Fermer</button>
          </div>
        </div>
      )}

      <Style />
    </div>
  );
}

/* ── HELPERS ── */
function clampInt(v, min, max) {
  const n = parseInt(String(v || ""), 10);
  return Number.isNaN(n) ? min : Math.max(min, Math.min(max, n));
}
function makeRows(n) {
  return Array.from({ length: n }, () => ({ stackId: "", commentaire: "" }));
}

/* ── STYLES ── */
function Style() {
  return (
    <style>{`
      *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

      .ab-page {
        min-height: 100vh; width: 100%;
        background: radial-gradient(ellipse at top, #01283a 0%, #010F14 70%);
        display: flex; justify-content: center; align-items: flex-start;
        padding: 16px;
        font-family: 'Inter','Segoe UI',sans-serif;
      }

      .ab-card {
        width: 100%; max-width: 680px;
        background: #011e2b;
        border: 1px solid #1a4a5a;
        border-radius: 16px; overflow: hidden;
        box-shadow: 0 8px 40px rgba(0,0,0,0.6), 0 0 0 1px #0a3040;
      }

      /* HEADER */
      .ab-header {
        background: linear-gradient(135deg, #E6FF3E 0%, #c8e800 100%);
        color: #000; padding: 14px 20px;
        display: flex; flex-direction: column; align-items: center; gap: 2px;
      }
      .ab-header span      { font-size: 15px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.1em; }
      .ab-header-sub       { font-size: 11px; font-weight: 500; opacity: 0.6; }

      /* NAV */
      .ab-nav {
        background: #010f14; padding: 8px 16px;
        display: flex; justify-content: space-between; align-items: center;
        border-bottom: 1px solid #1a4a5a;
      }
      .ab-btn-back {
        background: transparent; color: #7ab8cc;
        border: 1px solid #1a4a5a; border-radius: 6px;
        padding: 5px 10px; font-size: 11px; font-weight: 600; cursor: pointer;
        transition: all 0.2s;
      }
      .ab-btn-back:hover { background: #1a4a5a; color: #fff; }
      .ab-clock { text-align: right; }
      .ab-clock-time { color: #E6FF3E; font-size: 15px; font-weight: 700; font-variant-numeric: tabular-nums; }
      .ab-clock-date { color: #5a8a99; font-size: 10px; }

      /* FORM */
      .ab-form { padding: 20px; display: flex; flex-direction: column; gap: 18px; overflow-y: auto; flex: 1; }

      /* OPÉRATEUR */
      .ab-operator-badge {
        display: flex; align-items: center; gap: 10px;
        background: linear-gradient(90deg, #012836, #013d50);
        border: 1px solid #1a5a6a; border-radius: 10px;
        padding: 12px 16px; color: #fff; font-size: 14px; font-weight: 700; letter-spacing: 0.06em;
      }
      .ab-operator-dot {
        width: 10px; height: 10px; background: #00B050;
        border-radius: 50%; box-shadow: 0 0 6px #00B050; flex-shrink: 0;
      }

      /* SECTION */
      .ab-section {
        background: #012030; border: 1px solid #1a4a5a;
        border-radius: 12px; padding: 14px 16px;
        display: flex; flex-direction: column; gap: 10px;
      }
      .ab-section-final { border-color: #2a5a1a; background: #011a08; }
      .ab-section-table { padding: 14px 12px; }
      .ab-section-label {
        font-size: 12px; font-weight: 700; text-transform: uppercase;
        letter-spacing: 0.08em; color: #7ab8cc;
      }
      .ab-section-final .ab-section-label { color: #7aff9a; }

      /* INPUTS */
      .ab-input {
        width: 100%; background: #010F14; color: #fff;
        border: 1px solid #1a4a5a; border-radius: 8px;
        padding: 10px 14px; font-size: 15px; font-weight: 500;
        outline: none; transition: border 0.2s, box-shadow 0.2s;
        font-family: inherit;
      }
      .ab-input:focus { border-color: #E6FF3E; box-shadow: 0 0 0 2px rgba(230,255,62,0.15); }
      .ab-input-center { text-align: center; }
      .ab-input-small  { max-width: 160px; margin: 0 auto; display: block; }
      .ab-input-filled { background: #012836; color: #7aff9a; border-color: #00B050; font-weight: 700; }
      .ab-input-empty  { background: #020d12; color: #4a6a7a; border-style: dashed; }

      /* STACK ROW */
      .ab-stack-row {
        display: flex; gap: 8px; align-items: center; flex-wrap: wrap;
      }
      .ab-stack-input {
        flex: 1; min-width: 160px;
        background: #003818; color: #7aff9a;
        border: 1px solid #005020; border-radius: 8px;
        padding: 10px 14px; font-size: 14px; font-weight: 600;
        outline: none; transition: border 0.2s;
      }
      .ab-stack-input:focus { border-color: #00B050; box-shadow: 0 0 0 2px rgba(0,176,80,0.15); }
      .ab-scan-btn {
        width: 44px; height: 44px; background: #012030;
        border: 1px solid #1a4a5a; border-radius: 8px;
        font-size: 20px; cursor: pointer; transition: background 0.2s; flex-shrink: 0;
      }
      .ab-scan-btn:hover { background: #1a4a5a; }
      .ab-btn-action {
        background: #F2F2F2; color: #000;
        border: 2px solid #C00000; border-radius: 8px;
        padding: 8px 12px; font-weight: 700; font-size: 12px;
        cursor: pointer; white-space: nowrap; transition: opacity 0.2s;
        height: 44px;
      }
      .ab-btn-action:hover { opacity: 0.85; }
      .ab-btn-danger { background: #fff0f0; }

      /* DROPDOWN */
      .ab-dropdown {
        position: absolute; left: 0; right: 0; margin-top: 4px;
        max-height: 200px; overflow-y: auto;
        background: #002818; border: 1px solid #005020;
        border-radius: 8px; z-index: 50;
        box-shadow: 0 8px 24px rgba(0,0,0,0.5);
      }
      .ab-dropdown-item {
        padding: 8px 14px; color: #aaffcc; font-size: 13px;
        cursor: pointer; border-bottom: 1px solid #003818; transition: background 0.15s;
      }
      .ab-dropdown-item:hover { background: #003d20; }

      /* TABLEAU */
      .ab-table { border: 1px solid #1a4a5a; border-radius: 10px; overflow: hidden; }
      .ab-table-head {
        display: grid; grid-template-columns: 80px 1fr 1fr;
        background: linear-gradient(90deg, #012a3d, #013d50);
        border-bottom: 1px solid #1a4a5a;
      }
      .ab-th {
        padding: 10px 8px; text-align: center;
        font-size: 11px; font-weight: 700; text-transform: uppercase;
        letter-spacing: 0.06em; color: #7ab8cc;
        border-right: 1px solid #1a4a5a;
      }
      .ab-th:last-child { border-right: none; }
      .ab-table-row { display: grid; grid-template-columns: 80px 1fr 1fr; }
      .ab-row-even { background: #011820; }
      .ab-row-odd  { background: #012030; }
      .ab-table-row:not(:last-child) { border-bottom: 1px solid #1a3a4a; }
      .ab-td {
        padding: 6px 8px; text-align: center;
        display: flex; align-items: center; justify-content: center;
        border-right: 1px solid #1a3a4a;
      }
      .ab-td:last-child { border-right: none; }
      .ab-td-pos { color: #7ab8cc; font-size: 13px; font-weight: 700; }
      .ab-cell-input {
        width: 95%; background: #010f14; color: #fff;
        border: 1px solid #1a4a5a; border-radius: 6px;
        padding: 6px 8px; font-size: 12px; outline: none;
        transition: border 0.2s;
      }
      .ab-cell-input:focus { border-color: #E6FF3E; }
      .ab-cell-readonly { color: #7aff9a; cursor: not-allowed; border-style: dashed; }

      /* FINAL */
      .ab-final-row { display: flex; gap: 10px; align-items: center; }
      .ab-btn-create {
        flex: 1; background: linear-gradient(135deg, #1a4a5a, #012836);
        color: #E6FF3E; border: 1px solid #E6FF3E; border-radius: 8px;
        padding: 10px 14px; font-weight: 700; font-size: 13px;
        cursor: pointer; transition: opacity 0.2s;
      }
      .ab-btn-create:disabled { opacity: 0.5; cursor: not-allowed; }
      .ab-btn-create:hover:not(:disabled) { opacity: 0.85; }
      .ab-btn-print {
        background: #FFD966; color: #000;
        border: 2px solid #C00000; border-radius: 8px;
        padding: 10px 16px; font-weight: 800; font-size: 13px;
        cursor: pointer; white-space: nowrap; transition: opacity 0.2s; min-width: 90px;
      }
      .ab-btn-print:disabled { opacity: 0.5; cursor: not-allowed; }

      /* MESSAGES */
      .ab-msg { border-radius: 8px; padding: 10px 14px; font-size: 13px; font-weight: 600; }
      .ab-msg-error   { background: #2a0808; border: 1px solid #C00000; color: #ff9090; }
      .ab-msg-success { background: #002810; border: 1px solid #00B050; color: #80ff90; }

      /* SUBMIT */
      .ab-submit-row { display: flex; gap: 10px; align-items: center; }
      .ab-btn-submit {
        flex: 1;
        background: linear-gradient(135deg, #00B050, #008a3c);
        color: #000; border: none; border-radius: 10px;
        padding: 14px; font-size: 15px; font-weight: 800;
        text-transform: uppercase; letter-spacing: 0.08em;
        cursor: pointer; transition: opacity 0.2s, transform 0.1s;
        box-shadow: 0 4px 16px rgba(0,176,80,0.3);
      }
      .ab-btn-submit:hover:not(:disabled) { opacity: 0.9; transform: translateY(-1px); }
      .ab-btn-submit:disabled { opacity: 0.5; cursor: not-allowed; }
      .ab-btn-time {
        min-width: 110px; background: #C00000; color: #fff;
        border: 2px solid #7F0000; border-radius: 8px;
        padding: 8px 10px; font-weight: 700; font-size: 12px;
        cursor: default; text-align: center;
      }
      .ab-btn-time-sub { font-size: 11px; margin-top: 2px; font-variant-numeric: tabular-nums; }

      /* SCANNER MODAL */
      .ab-modal-backdrop {
        position: fixed; inset: 0; background: rgba(0,0,0,0.8);
        display: flex; justify-content: center; align-items: center;
        z-index: 999; backdrop-filter: blur(4px);
      }
      .ab-modal-scanner {
        width: 90%; max-width: 420px; background: #011e2b;
        border: 1px solid #00B050; border-radius: 14px; padding: 16px;
        display: flex; flex-direction: column; gap: 12px;
        box-shadow: 0 0 40px rgba(0,176,80,0.2);
      }
      .ab-modal-title { color: #fff; font-size: 14px; font-weight: 700; text-align: center; }
      .ab-btn-close-scanner {
        background: #C00000; color: #fff; border: none;
        border-radius: 8px; padding: 10px; font-weight: 700;
        font-size: 13px; cursor: pointer; transition: opacity 0.2s;
      }
      .ab-btn-close-scanner:hover { opacity: 0.85; }

      /* TABLETTE */
      @media (min-width: 768px) {
        .ab-card    { max-width: 780px; }
        .ab-header span { font-size: 18px; }
        .ab-form    { padding: 24px 28px; gap: 22px; }
        .ab-input   { font-size: 16px; padding: 12px 16px; }
        .ab-section-label { font-size: 13px; }
        .ab-btn-submit { font-size: 16px; padding: 16px; }
        .ab-table-head, .ab-table-row { grid-template-columns: 100px 1fr 1fr; }
        .ab-th, .ab-cell-input { font-size: 13px; }
      }

      /* DESKTOP */
      @media (min-width: 1024px) {
        .ab-card    { max-width: 960px; }
        .ab-header span { font-size: 22px; }
        .ab-form    { padding: 28px 36px; gap: 26px; }
        .ab-input   { font-size: 18px; padding: 14px 18px; }
        .ab-operator-badge { font-size: 16px; padding: 14px 20px; }
        .ab-section { padding: 18px 20px; }
        .ab-section-label { font-size: 14px; }
        .ab-btn-submit { font-size: 18px; padding: 18px; }
        .ab-clock-time { font-size: 18px; }
        .ab-stack-input { font-size: 16px; padding: 12px 16px; }
        .ab-scan-btn    { width: 52px; height: 52px; font-size: 24px; }
        .ab-btn-action  { font-size: 13px; padding: 10px 16px; height: 52px; }
        .ab-table-head, .ab-table-row { grid-template-columns: 110px 1fr 1fr; }
        .ab-th { font-size: 13px; padding: 12px; }
        .ab-cell-input { font-size: 14px; padding: 8px 10px; }
        .ab-td-pos { font-size: 15px; }
      }

      /* XXL */
      @media (min-width: 1400px) {
        .ab-page  { padding: 32px; }
        .ab-card  { max-width: 1200px; border-radius: 20px; }
        .ab-header { padding: 24px 40px; }
        .ab-header span  { font-size: 28px; letter-spacing: 0.14em; }
        .ab-header-sub   { font-size: 14px; }
        .ab-nav   { padding: 12px 28px; }
        .ab-btn-back { font-size: 13px; padding: 7px 14px; }
        .ab-clock-time   { font-size: 22px; }
        .ab-clock-date   { font-size: 12px; }
        .ab-form  { padding: 36px 48px; gap: 32px; }
        .ab-operator-badge { font-size: 20px; padding: 16px 24px; border-radius: 14px; }
        .ab-operator-dot   { width: 14px; height: 14px; }
        .ab-section { padding: 22px 26px; gap: 14px; border-radius: 16px; }
        .ab-section-label  { font-size: 15px; letter-spacing: 0.1em; }
        .ab-input   { font-size: 22px; padding: 16px 20px; border-radius: 10px; }
        .ab-input-small    { max-width: 200px; }
        .ab-stack-input    { font-size: 20px; padding: 14px 20px; border-radius: 10px; height: 58px; }
        .ab-scan-btn       { width: 64px; height: 64px; font-size: 28px; border-radius: 10px; }
        .ab-btn-action     { font-size: 15px; padding: 12px 20px; height: 64px; border-radius: 10px; }
        .ab-table-head, .ab-table-row { grid-template-columns: 130px 1fr 1fr; }
        .ab-th    { font-size: 14px; padding: 14px; }
        .ab-cell-input     { font-size: 16px; padding: 10px 12px; border-radius: 8px; }
        .ab-td-pos         { font-size: 18px; }
        .ab-td    { padding: 10px 8px; }
        .ab-btn-create     { font-size: 16px; padding: 14px 20px; border-radius: 10px; }
        .ab-btn-print      { font-size: 16px; padding: 14px 20px; border-radius: 10px; min-width: 120px; }
        .ab-msg   { font-size: 15px; padding: 14px 18px; border-radius: 10px; }
        .ab-btn-submit     { font-size: 22px; padding: 22px; border-radius: 14px; letter-spacing: 0.1em; }
        .ab-btn-time       { min-width: 160px; font-size: 14px; padding: 12px; border-radius: 10px; }
        .ab-btn-time-sub   { font-size: 13px; }
      }
    `}</style>
  );
}
